import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import BootstrapVue3 from 'bootstrap-vue-3';
import VueGoogleMaps from '@fawmi/vue-google-maps';
import EChartsPlugin from './plugins/echarts'
import { initApiLogging } from './api/client';
import { SUCURSAL_OPTIONS, LOT_OPTIONS, LOT_AUTHORITY_OPTIONS } from './constants/branches';
import brand from './branding';
import './styles/brand-topbar.css';
import './styles/note-secondary-tabs.css';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue-3/dist/bootstrap-vue-3.css';

initApiLogging({
	router,
	exclude: [
		'/api/current-user/',
		'/api/monitoring/',
		'/api/fetch-last-vehicle-locations2',
		'/api/fetch-last-vehicle-locations-new',
		'/api/get-distance-and-time',
		'/api/get-services-metadata',
		'/api/get-unit-services-metadata-filtered',
		'/api/create-identifier',
		'/api/get-tows-status',
		'/api/get-privileged-clients',
		'/api/health-check',
		'/api/get-assignations-operator',
		'/api/get-brands',
		'/api/get-filtered-sub-brands',
		'/api/get-sub-brand',
		'/api/get-services-metadata-statistics',
		'/api/get-files/',
		'/api/get-global-filtered-statistics',
		'/api/get-global-filtered-invoice-statistics',
		'/api/get-services-metadata-filtered',
		'/api/get-note-assignations',
		'/api/get-scheduled-services-metadata-statistics',
		'/api/get-scheduled-services-metadata-filtered',
		'/api/dashboard/',
		'/api/insurer/services?state=pending',
		// Chat polls every few seconds; logging it would flood the request log.
		'/api/notes/chat/active-threads/',
		/\/api\/notes\/[^/]+\/chat\//,
	],
});

document.body.classList.add(`brand-${brand.id}`);

const app = createApp(App)

// Exposed globally so every dropdown can read the catalogs straight from the
// template without each component importing them.
app.config.globalProperties.$catalogs = {
	sucursales: SUCURSAL_OPTIONS,
	lotes: LOT_OPTIONS,
	autoridades: LOT_AUTHORITY_OPTIONS,
}

app
	.use(router)
	.use(store)
	.use(BootstrapVue3)
	.use(EChartsPlugin)
	.use(VueGoogleMaps, {
		load: {
			key: 'AIzaSyDttJadFf5cWEcGQMFmRZCrjzUFony74xI',
		},
		})
	.directive('click-outside', {
		beforeMount(el, binding) {
			el.clickOutsideEvent = function (event) {
				if (!(el.contains(event.target))) {
					binding.value(event);
				}
			};
			document.addEventListener('click', el.clickOutsideEvent)
		},
		unmounted(el) {
			document.removeEventListener('click', el.clickOutsideEvent)
		},
	})  
	.mount('#app')
